import { IPermanentDebtInfo } from 'views/ProFormaTable/types';

export const getDebtName = (debt: IPermanentDebtInfo, index: number): string => {
    if (debt.name) {
        return debt.name;
    }
    if (debt.isSenior) {
        return 'Senior loan';
    }
    return `Loan #${index + 1}`;
};
